import en from './en';
import is from './is';

export default {
  is,
  en,
};
